import config from '../../config';

export const paymentHost = config.config.api_payments.host;
